export default {
  tabs: {
    online_shop: 'Onlineshop',
    reservations: 'Reservationer',
    storefront: 'Butik',
  },
};
